"use strict";
import moment from "moment";
export default {
  weight: function(number_or_string) {
    var number = number_or_string;
    if (_.isString(number_or_string)) {
      number = parseInt(number_or_string);
    }
    return number ? "" + _.str.numberFormat(number) + " lbs" : null;
  },
  ein: function(string) {
    if (!_.str.isBlank(string)) {
      var prefix = string.substr(0, 2);
      var suffix = string.substr(2, 7);
      return prefix + "-" + suffix;
    }
  },
  currency: function(string) {
    if (!_.str.isBlank(string)) {
      var parsed = parseFloat(string);
      var formatted = "$" + _.str.numberFormat(Math.abs(parsed), 2);
      if (parsed < 0) {
        return "(" + formatted + ")";
      } else {
        return formatted;
      }
    }
  },
  // not really a formatter per se but might be better to keep it with
  // other things like it?
  cleanAmount: function(amount) {
    if (amount) {
      var regexMaybeDollar = /\s*\$?\s*/;
      var regexMaybeSign = /(-?)\s*/;
      var regexCentsOnly = /((\s*[.,]\s*)(\d{1,2}))/;
      var regexDollarsWithDelimiters = /((\d{1,3})(\s*[.,]\s*)(\d{3}))/;
      var regexDollarsNoDelimiters = /(\d{1,6})/;
      var regexDollarsAndCents = new RegExp("(" + regexDollarsWithDelimiters.source + "|" + regexDollarsNoDelimiters.source + ")(" + regexCentsOnly.source + ")?");
      var regex = new RegExp(
        regexMaybeDollar.source + regexMaybeSign.source + "(" + regexCentsOnly.source + "|" + regexDollarsAndCents.source + ")\\s*"
      );
      var matches = regex.exec(amount);
      if (matches === null || matches.length < 16) {
        return null;
      }
      var sign = matches[1];
      var result = 0;
      if (matches[5] && matches[5].length > 0) {
        var cents = matches[5];
        var toParse = sign + "0." + cents;
        result = parseFloat(toParse).toFixed(2);
      } else {
        var dollars = matches[6].replace(/\s/g, "").replace(/\./, "").replace(/,/, "") || "0";
        var cents = matches[15] || "00";
        var toParse = sign + dollars + "." + cents;
        result = parseFloat(toParse).toFixed(2);
      }
      return result;
    } else {
      return null;
    }
  },
  date: function(dateTime) {
    if (_.isEmpty(dateTime)) return "N/A";
    return moment(dateTime).format("ll");
  },
  dateTime: function(dateTime) {
    return moment(dateTime).format("lll");
  },
  shortDate: function(dateTime) {
    return moment(dateTime).format("MM/DD/YYYY");
  },
  superShortDate: function(dateTime) {
    return moment(dateTime).format("M/D/YY");
  },
  shortTime: function(dateTime) {
    return moment(dateTime).format("hh:mm A");
  },
  shortDateTime: function(dateTime) {
    return `${this.shortDate(dateTime)} ${this.shortTime(dateTime)}`;
  },
  superShortTime: function(dateTime) {
    return moment(dateTime).format("h:mm A");
  },
  submissionStrategyToString: function(strategy) {
    if (strategy == "factor_only") {
      return "Factor Only - Documents submitted in the app go directly into TriumphPay Audit";
    } else if (strategy == "portal_only") {
      return "Portal Only - Documents submitted in the app go directly to the Portal";
    }
    ;
  }
};
